import { useMutation, useQuery } from "@tanstack/react-query"
import { Api } from "@/api/worker"
import { Path } from "@/router"

export function useCreateCheckoutSession() {
	const url: Path = "/stripe-return"
	const redirectUrl = `${window.location.origin}${url}`
	return useMutation({
		mutationFn: (params: { months: number; reportId: string; productName: string }) =>
			Api.createCheckoutSession({
				query: {
					months: params.months,
					currency: "usd",
					payment_method: "pm_card_visa",
					report_id: params.reportId,
					return_url: redirectUrl,
					productName: params.productName,
				},
			}),
		onError: (error) => {
			console.error("Payment error:", error)
		},
	})
}
